(function ($, root, undefined) {
  $(function () {
    console.log("Mush Works");

    // SMOOTH SCROLL TO ANCHOR
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function (event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, "") ==
            this.pathname.replace(/^\//, "") &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length
            ? target
            : $("[name=" + this.hash.slice(1) + "]");
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            var menuHeight = $(".mush-submenu").outerHeight(true);
            var headerHeight = $("#shopify-section-header").outerHeight(true);
            $("html, body").animate(
              {
                scrollTop: target.offset().top - menuHeight,
              },
              300,
              function () {
                // Callback after animation
                // Must change focus!
                var $target = $(target);
                //$target.focus();
                if ($target.is(":focus")) {
                  // Checking if the target was focused
                  return false;
                } else {
                  $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                  //$target.focus(); // Set focus again
                }
              }
            );
          }
        }
      });

    $("#mush-mobile-nav-trigger > span").click(function (e) {
      $(this).addClass("d-none");

      if ($(this).hasClass("closed")) {
        $(this).next().removeClass("d-none");
        $(".mush-submenu .submenu-links").addClass("open");
      } else {
        $(this).prev().removeClass("d-none");
        $(".mush-submenu .submenu-links").removeClass("open");
      }
    });

    // Mush Sub Menu
    $(window).scroll(function() {
      if($(this).scrollTop() > $('#shopify-section-header').outerHeight() + 40){
        $('.mush-submenu').addClass('sticky-added');
      } else {
        $('.mush-submenu').removeClass('sticky-added');
      }
    });
  });
})(jQuery, this);
